import React from 'react';
export const clockSvg = () => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0589 2C6.55464 2 2.09741 6.48 2.09741 12C2.09741 17.52 6.55464 22 12.0589 22C17.5731 22 22.0403 17.52 22.0403 12C22.0403 6.48 17.5731 2 12.0589 2ZM12.0688 20C7.66147 20 4.0917 16.42 4.0917 12C4.0917 7.58 7.66147 4 12.0688 4C16.4762 4 20.046 7.58 20.046 12C20.046 16.42 16.4762 20 12.0688 20Z"
                fill="#565671"/>
            <path d="M12.5672 7H11.0715V13L16.3065 16.15L17.0544 14.92L12.5672 12.25V7Z" fill="#565671"/>
        </svg>
    )
}